import { Stack, StackProps, Typography } from '@mui/material';
import React from 'react';

interface FormSubsectionProps extends StackProps {
  children?: React.ReactNode;
  title?: string;
  heading?: React.ReactNode;
  disabled?: boolean;
}

function FormSubsection({ children, title, heading, disabled, ...rest }: FormSubsectionProps) {
  const renderHeading = () => {
    if (heading) {
      return <Stack mb={2}>{heading}</Stack>;
    }
    if (title) {
      return (
        <Typography variant="body2" mb={2} color={disabled ? 'text.disabled' : 'text.primary'}>
          {title}
        </Typography>
      );
    }
    return null;
  };

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Stack width={1} {...rest}>
      {renderHeading()}
      <Stack>{children}</Stack>
    </Stack>
  );
}

export default FormSubsection;